export const initialValues = {
  "name": "",
  "idStation": "",
  "ip": "",
}
  
export const fieldValidations = {
  "name": {
    "required": true
  },
  "idStation": {
    "required": true
  },
  "ip": {
    "required": true
  },
}
  